import React, {useState, useCallback, useMemo} from 'react';
import Joyride, {CallBackProps, Step, Styles, type FloaterProps, EVENTS , STATUS} from 'react-joyride';
import OnboardingDialog from '../shared/molecule/onboarding/OnboardingDialog';
import {createFreeCustomTooltipWrapper} from './FreeCustomTooltip';

interface AppTourProps extends Partial<FloaterProps> {
  steps: Step[];
  modalTitle?: string;
  modalDescription?: string;
  modalActionLabel?: string;
  onModalAction: () => void;
  completedStepsRef: React.MutableRefObject<number>;
}

const tourStyles: Partial<Styles> = {
  options: {
    primaryColor: '#F3F3F3',
    backgroundColor: 'rgba(0,0,0,0.85)',
    textColor: '#fff',
    zIndex: 2100,
  },
  buttonBack: {
    display: 'none',
  },
  buttonSkip: {
    display: 'none',
  },
};

const DashBoardAppTourComponent: React.FC<AppTourProps> = ({
                                                             steps,
                                                             modalTitle,
                                                             modalDescription,
                                                             modalActionLabel,
                                                             onModalAction,
                                                             completedStepsRef,
                                                           }) => {
  const [showTour, setShowTour] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const floaterProps = useMemo(() => ({
    hideArrow: true,
  }), []);

  const locale = useMemo(() => ({
    last: 'Finish',
    next: 'Next',
  }), []);

  const handleJoyrideCallback = useCallback((data: CallBackProps) => {
    const {status, type, index} = data;

    if (type === EVENTS.STEP_AFTER) {
      if (index === 0) {
        const optOutRequestsTab = document.querySelector('.opt-out-requests-tab');
        if (optOutRequestsTab) {
          (optOutRequestsTab as HTMLElement).click();
        }
      }
    }

    if ((status === STATUS.FINISHED || status === STATUS.SKIPPED) && type === EVENTS.TOUR_END) {
      setShowTour(false);
      setShowModal(true);
      completedStepsRef.current += 1;
    }
  }, [completedStepsRef]);

  return (
    <>
      <Joyride
        steps={steps}
        run={showTour}
        continuous
        showSkipButton={false}
        tooltipComponent={createFreeCustomTooltipWrapper(true)}
        showProgress={false}
        styles={tourStyles}
        callback={handleJoyrideCallback}
        disableCloseOnEsc
        locale={locale}
        floaterProps={floaterProps}
      />
      <OnboardingDialog
        open={showModal}
        onAction={onModalAction}
        title={modalTitle}
        description={modalDescription}
        actionLabel={modalActionLabel}
      />
    </>
  );
};

DashBoardAppTourComponent.displayName = 'DashBoardAppTour';

export const DashBoardAppTour = React.memo(DashBoardAppTourComponent);
